import styled from "styled-components";

export const QrWrapper = styled.div<{ $horizontalAlignment?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: ${({ $horizontalAlignment }) =>
    $horizontalAlignment || "center"};
  a,
  a:hover {
    text-decoration: none !important;
  }
`;

export const QrBox = styled.div`
  max-width: 100%;
  /* Lets the centre icon size itself in cqw against the code's width. */
  container-type: inline-size;
`;
